import AddRemoveTableSortable from "components/AddRemoveTableSortable"
import Entity from "components/AddRemoveTableSortable/types/Entity"
import addAllFilterValues from "pages/AddPermission/utils/addAllFilterValues"
import removeAllFilterValues from "pages/AddPermission/utils/removeAllFilterValues"

interface RecursiveFilterBlockProps {
  filter: any
  id: number | undefined
  isCreate: boolean
  apiUrls: any
  selectedFilter: any
  selectedFilterAndChildrenIdsFlat: any
  setShowOverlay: Function
  onAddItem?: (entity: Entity) => boolean
  onRemoveItem?: (entity: Entity) => boolean
  onAddAllItemsInvertedInitialSelection?: (entities: Entity[]) => boolean
  showRecentOnly?: boolean
}

const RecursiveFilterBlock: React.FC<RecursiveFilterBlockProps> = ({
  filter,
  id,
  isCreate,
  apiUrls,
  selectedFilter,
  selectedFilterAndChildrenIdsFlat,
  setShowOverlay,
  onAddItem,
  onRemoveItem,
  onAddAllItemsInvertedInitialSelection,
  showRecentOnly
}) => {
  return (
    <div className='mb-5 filter-block'>
      <div className={!isCreate || ([null, undefined].includes(selectedFilter) || selectedFilterAndChildrenIdsFlat.includes(filter.id)) ? '' : 'd-none'}>
        <AddRemoveTableSortable
          key={filter.id}
          showRecentOnly={showRecentOnly}
          getAllRowsUrl={
            apiUrls.filterValuesToPermissions + '?id=' + id + '&filter_id=' + filter.id
          }
          addRemoveRowUrl={apiUrls.filterValuesToPermissions}
          relationalFieldName='filter_value_id'
          maxTableHeight='750px'
          entityNameSingular='Filter Value'
          entityNamePlural={filter.name + ' - Filter Values'}
          setShowOverlay={setShowOverlay}
          invertInitialSelection={isCreate}
          showSelectAll={true}
          showDeselectAll={true}
          enableSearch={true}
          enablePagination={true}
          showDataInitSpinner={true}
          onAddItem={onAddItem}
          onAddAllItems={isCreate ? undefined : async (entities: Entity[]) =>{
            return await addAllFilterValues({filterId: filter.id, permissionId: id!, recentOnly: showRecentOnly})
          }}
          onRemoveItem={onRemoveItem}
          onRemoveAllItems={isCreate ? undefined : async (entities: Entity[], setIncludedRows: React.Dispatch<React.SetStateAction<Entity[]>>) =>{
            const ret = await removeAllFilterValues({filterId: filter.id, permissionId: id!, recentOnly: showRecentOnly})
            if(ret){
              setIncludedRows([])
            }
            return ret
          }}
          onAddAllItemsInvertedInitialSelection={onAddAllItemsInvertedInitialSelection}
        />
      </div>

      <div className='col-12 ps-2'>
        {filter.filters?.map((subFilter: any) => (
          <RecursiveFilterBlock
            key={subFilter.id}
            showRecentOnly={showRecentOnly}
            filter={subFilter}
            id={id}
            isCreate={isCreate}
            apiUrls={apiUrls}
            selectedFilterAndChildrenIdsFlat={selectedFilterAndChildrenIdsFlat}
            selectedFilter={selectedFilter}
            setShowOverlay={setShowOverlay}
            onAddItem={onAddItem}
            onRemoveItem={onRemoveItem}
            onAddAllItemsInvertedInitialSelection={onAddAllItemsInvertedInitialSelection}
          />
        ))}
      </div>
    </div>
  )
}

export default RecursiveFilterBlock